import { makeStyles } from "@material-ui/core";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import clsx from 'clsx';
import { DashboardHeader } from "pages/admin/dashboard/components/general";

const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: 5, },
    '&::-webkit-scrollbar-thumb': { background: '#999999' }
  },
  chart: {
    width: '100%',
    height: '100%',
  },
  wrapRow: {
    padding: "5px 10px", borderBottom: "1px solid #F3f3f3",
    display: 'flex',
    justifyContent: 'space-between'
  },
  wrapUser: {
    display: 'flex',
    alignItems: 'center'
  },
  userInfo: {
    fontSize: "12px", marginLeft: "5px", color: "#707070"
  },
  wrapHeadRow: {
    padding: "5px 10px",
  },
  wrapRequestNum: {
    display: 'flex',
    // justifyContent: ''
  },
  requestNum: {
    width: "50px", color: "#707070", fontSize: "12px", fontWeight: "bold", textAlign: 'center'
  },
  overdue: {
    color: "orangered", textDecoration: "underline"
  },
  wrapTitle: {
    color: "#707070", fontSize: "12px", marginLeft: "5px", fontWeight: 'initial'
  }
}));


const data = [
  {
    departName: "NIA",
    request: 10,
    requestOverdue: 1
  },
  {
    departName: "DEPA",
    request: 7,
    requestOverdue: 3
  },
  {
    departName: "NSTDA",
    request: 6,
    requestOverdue: 0
  },
  {
    departName: "CAAT",
    request: 9,
    requestOverdue: 3
  },
  {
    departName: "Immigration Bureau",
    request: 3,
    requestOverdue: 0
  },
]

function CertifyingAgency(props) {
  const classes = useStyles();

  const _data = props.data;

  return (
    <>
      <div>
        <DashboardHeader title="Certifying Agencies" onSelectViewAll={() => {
          props.onSelectViewAll()
        }} />
      </div>
      <div className={classes.wrapChart}>
        {/* <div className={classes.wrapHeadRow}>
          <div className={classes.wrapUser}>
            <div className={classes.userHeadInfo}>
              หน่วยงาน
            </div>
          </div>

          <div>

          </div>
          <div>

          </div>
        </div> */}

        <div className={classes.wrapRow}>
          <div className={classes.wrapUser}>

            <div className={classes.userInfo}>
              หน่วยงาน
            </div>
          </div>
          <div className={classes.wrapRequestNum}>
            <div className={clsx(classes.requestNum, classes.wrapTitle)}  >
              ทั้งหมด
            </div>
            <div className={clsx(classes.requestNum, classes.wrapTitle)}>
              เกินเวลา
            </div>
          </div>

        </div>
        {
          _data?.map((d, index) => (
            <div key={index} className={classes.wrapRow}>
              <div className={classes.wrapUser}>
                <AccountCircleIcon />
                <div className={classes.userInfo}>
                  {d.departmentInitials}
                </div>
              </div>
              <div className={classes.wrapRequestNum}>
                <div className={classes.requestNum}>
                  {d.jobCount}
                </div>
                <div className={clsx(classes.overdue, classes.requestNum)}>
                  {d.overdue}
                </div>
              </div>

            </div>
          ))
        }

      </div>
    </>
  )
}


export default CertifyingAgency;